import { render, staticRenderFns } from "./ButtonEmailVerification.vue?vue&type=template&id=4855ba83&scoped=true"
import script from "./ButtonEmailVerification.vue?vue&type=script&lang=js"
export * from "./ButtonEmailVerification.vue?vue&type=script&lang=js"
import style0 from "./ButtonEmailVerification.vue?vue&type=style&index=0&id=4855ba83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4855ba83",
  null
  
)

export default component.exports